// extracted by mini-css-extract-plugin
export default {"tabSelectorContainer":"tabSelectorContainer-1vwl7","tabSelector":"tabSelector-r8Cxj","btnTab":"btnTab-36Vkt","activeTab":"activeTab-33_py"};